import { SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { createPricingLevelActions } from "@/App/actions";
import { PricingLevelsTypes } from "@/types";
import { NavigateFunction } from "react-router";

const redirectPage = (id: number, navigate: NavigateFunction) => navigate(`/pricing-levels/${id}/edit`);

function* createPricingLevel(payload: PricingLevelsTypes.PricingLevel): Generator {
  return yield apiService({
    url: "/pricing_level/create",
    method: "POST",
    data: payload,
  });
}

export function* createPricingLevelWorker(
  action: ReturnType<typeof createPricingLevelActions.createPricingLevel>,
): SagaIterator {
  const { payload, formName, navigate } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const { id } = yield call(createPricingLevel, payload);

    yield put(stopSubmit(formName));

    // redirect to edit page
    redirectPage(id, navigate);
    yield put(showPageAlert({ show: true, type: "success", message: "Pricing level added successfully." }));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(stopSubmit(formName));
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* createPricingLevelWatcher(): SagaIterator {
  yield takeEvery(ActionTypes.CREATE_PRICING_LEVEL, createPricingLevelWorker);
}
